import { Row, Col, Alert, Card, Space, Typography, Statistic } from 'antd';
import type { SimulationDetail } from '../../store/simulation/types';
import { palette } from '@shipium-corp/shipium-ui-theme';
import { useSimulationReport } from '../../hooks/simulation/useSimulationReport';
const { Title } = Typography;
export interface ShipmentLimitsReportTabProps {
  simulation: SimulationDetail;
}

export const ShipmentLimitsReportTab = ({ simulation }: ShipmentLimitsReportTabProps) => {
  const { reportData: data, loading } = useSimulationReport(simulation, 'cost-adjustment-report');
  const isComplete = simulation.simulationStatus === 'completed';

  const targetCarrier = data?.targetCarrier.toUpperCase();

  return (
    <Row gutter={16}>
      <Col span={24}>
        {!isComplete && (
          <Alert
            type={'warning'}
            showIcon={true}
            description={'The Shipment Limits report will be available once the simulation has completed execution.'}
            message={'Simulation Incomplete'}
          />
        )}
        {isComplete && data && (
          <div>
            <Row gutter={32}>
              <Col span={8}>
                <Card bordered={true} style={{ background: '#fafafa' }} loading={loading}>
                  <Title level={4}>Target Carrier Percentage: {targetCarrier}</Title>
                  <Space size={'large'}>
                    <Statistic
                      title={'Target Percentage'}
                      value={data.desiredTargetPercent * 100}
                      precision={2}
                      valueStyle={{ color: palette.Grey.dark }}
                      suffix={'%'}
                    />
                    <Statistic
                      title={'Effective Percentage'}
                      value={data.effectiveTargetPercentage * 100}
                      precision={2}
                      valueStyle={{ color: palette.Grey.dark }}
                      suffix={'%'}
                    />
                  </Space>
                </Card>
              </Col>
              <Col span={8}>
                <Card bordered={true} style={{ background: '#fafafa' }} loading={loading}>
                  <Title level={4}>Target Carrier Shipments: {targetCarrier}</Title>
                  <Space size={'large'}>
                    <Statistic
                      title={'Target Count'}
                      value={data.desiredTargetPercent * data.totalCount}
                      precision={0}
                      valueStyle={{ color: palette.Grey.dark }}
                    />
                    <Statistic
                      title={'Effective Count'}
                      value={data.effectiveTargetPercentage * data.totalCount}
                      precision={0}
                      valueStyle={{ color: palette.Grey.dark }}
                    />
                  </Space>
                </Card>
              </Col>
              <Col span={8}>
                <Card bordered={true} style={{ background: '#fafafa' }} loading={loading}>
                  <Title level={4}>Target Carrier Adjustment Amount: {targetCarrier}</Title>
                  <Space size={'large'}>
                    <Statistic
                      style={{ width: '150px' }}
                      title={'Per Shipment'}
                      value={data.costsByPercentile[data.desiredTargetPercent]}
                      precision={2}
                      valueStyle={{ color: palette.Grey.dark }}
                      prefix={'$'}
                    />
                  </Space>
                </Card>
              </Col>
            </Row>
          </div>
        )}
      </Col>
    </Row>
  );
};
